<!--考级中心 我的社群-->
<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-table ref="table" :data="list" row-key="id" :show-header="false">
        <el-table-column label="用户信息" fixed="left" prop="title">
          <template scope="scope">
            <img :src="scope.row.face"
                 alt="" class="cell-img">
            <div class="custom-title">{{ scope.row.user_name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="身份" prop="zhuantai">
          <template scope="scope">
            {{ scope.row.user_type }}
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="caozuo">
          <template scope="scope,index">
            <el-button class="look-order" v-if="scope.row.type != 1" size="medium" @click="deleteUser(scope.row.user_id, index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col class="footer-button">
          <el-button
              type="primary"
              @click="toUserCreate"
          >新增用户
          </el-button>
          <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
        </el-col>
      </el-row>
    </div>

    <JianduPicker
        :show="showJianduPicker"
        :limit="1"
        @onChange="onJianduChange"
        @onClose="showJianduPicker=false"
        :defaultValue="formData.jiandu"
        @onConfirm="onJianduConfirm"
    ></JianduPicker>
  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
}

.custom-title {
  line-height: 48px;
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}

.qcxj-community-box .van-cell__right-icon {
  line-height: 48px;
}


</style>
<script>
import Vue from 'vue';
import JianduPicker from '@/components/picker/JianduPicker.vue';

import {Cell,Field,Area,DatetimePicker,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Dialog ,Button,Calendar} from 'vant';

Vue.use(Cell).use(CellGroup).use(DatetimePicker).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Dialog).use(Button);
export default {
  name: 'QcxjDetailCommunity',
  components: {
    JianduPicker,
  },
  data: function () {
    return {
      showDate:false,
      showKaoguanPicker:false,
      showCenterPicker:false,
      showJianduPicker:false,
      saveLoading:false,
      showArea:false,
      areaList:{},
      areaValue:'',
      submitType:'',
      row:{

      },

      minDate: new Date( new Date(new Date().toLocaleDateString()).getTime() +3600*24*15*1000), //15天后
      formData: {
        id: 0,
        datetitle:'',
        areas:'',
        kaoguan:[],
        jiandu:[],
        extra_center:[],
        province:'',
        city:'',
        county:'',
      },

      isLoading: false,
      loading: false,
      finished: false,
      params: {
        id: 0,
        pageNo: 1,
        pageSize: 10,
      },
      list: []
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.params.id = this.$route.query.id||0;
    document.title = "成员信息"

    this.getUserList();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion(){
      console.log('onQuestion')
    },

    getUserList() {
      let that = this;
      that.$api.get('/api/examecenter/userList', that.params, (res) => {

        that.loading = false;
        that.params.pageNo += 1;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list;
        } else {
          let list = that.list.concat(res.data.list);
          that.list = list;
        }
        if (res.data.list.length == 0) {
          that.finished = true;
        }
      })
    },

    deleteUser(user_id, index) {
      let that = this;
      Dialog.confirm({
        title: '删除用户',
        message: '确定删除该用户吗?'
      }).then(() => {
        // on confirm
        that.$api.get('/api/examecenter/centerUserDelete', {
          'center_id': that.params.id,
          'user_id': user_id
        }, (res) => {
          Toast.success('删除成功')
          that.list.splice(index, 1);
        })
      }).catch(() => {
        // on cancel
      });
    },

    toUserCreate() {
      rbLink({name: 'QcxjDetailCommunityAdd', query: {id: this.params.id}})
      // this.$router.push({name: 'SiteSettingUserCreate'})
    },

    // 上拉加载
    onLoad() {
      // 异步更新数据
      if(this.params.pageNo > 1) {
        setTimeout(() => {
          this.getUserList()
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      this.getUserList(1)
    },
    onJianduConfirm(values){
      console.log('onJianduConfirm',values)
      this.showJianduPicker = false;
      this.formData.jiandu = [...values];
    },

    onJianduChange(values){
      console.log('onJianduChange',values)
      this.formData.jiandu = [...values];
    },
    onCenterChange(values){
      console.log('onCenterChange',values)
      this.formData.extra_center = [...values];
    },
    onSubmit(values){
      console.log('onSubmit-values',values);
      console.log('submitType',this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
        if (this.formData.kaoguan.length<2) {
          Toast('至少选择2个考官');
          return
        }
      }
      that.saveLoading = true;

      if (that.submitType =='save') {
        that.$api.post('/api/qcxj/kaojiApplySave', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      } else {
        that.$api.post('/api/qcxj/kaojiApplyAdd', that.formData, (res) => {
          that.saveLoading = false;
          rbLink({
            'name' : 'ExameApplyDetail',
            'query':{
              id: res.data.id
            }
          },'replace')
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      }
    },
    save(values){
      this.submitType = 'save';
    },
    onFailed(errorInfo){
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch(){
      let that = this;
      that.$api.post('/api/examecenter/centerdetail', {
        id:that.formData.id
      }, (res) => {
        that.formData = res.data;
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// QcxjDetailCommunity.vue?829ddcca